import * as React from 'react'
import { createContext, PropsWithChildren, ReactElement } from 'react'
import { useConst } from '@fluentui/react-hooks'
import { createQueueStore, QueueStore } from './queueStore'

// Kept as an alias so existing imports of `Queue` keep working.
export type Queue = QueueStore

const QueueContext = createContext<QueueStore | undefined>(undefined)

export function GenerationQueueProvider(props: PropsWithChildren): ReactElement {
    // The store is created once and never replaced, so this context value never changes identity and this provider
    // never re-renders. Consumers subscribe to the individual jobs they care about through the hooks in useQueue.
    const queue = useConst(createQueueStore)

    return <QueueContext.Provider value={queue}>{props.children}</QueueContext.Provider>
}

export default QueueContext
